export const Analyze1 = ({ size = "16" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_78_228)">
        <path
          d="M17.032 17.9747L12.886 13.8287C11.698 14.8033 10.2227 15.3333 8.66667 15.3333C4.99067 15.3333 2 12.3427 2 8.66667C2 4.99067 4.99067 2 8.66667 2C10.1947 2 11.6 2.522 12.7253 3.39L11.8533 4.4C10.9633 3.73333 9.862 3.33333 8.66667 3.33333C5.726 3.33333 3.33333 5.726 3.33333 8.66667C3.33333 9.44467 3.50467 10.1827 3.806 10.8493L7.28467 6.67467L9.62733 9.01733L15.4913 2.22667L16.5007 3.09867L9.69867 10.9747L7.37467 8.65067L4.54467 12.0467C5.52333 13.2387 7.008 14.0007 8.66667 14.0007C10.0913 14.0007 11.4307 13.446 12.438 12.4387C13.4453 11.4313 14 10.092 14 8.66733C14 8.46667 13.9867 8.27 13.9653 8.07533L15.0633 6.804C15.236 7.396 15.3333 8.02067 15.3333 8.668C15.3333 10.224 14.8033 11.6993 13.8287 12.8873L17.9747 17.0333L17.032 17.976V17.9747Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_228">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
